import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";

export const useDeleteImage = () => {
  return useMutation(async (path: string) => {
    await createApiWithPath("crm").post("/field-values/image/delete", { path });
  });
};
